import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64678694"),n=n(),_popScopeId(),n)
const _hoisted_1 = { role: "topic" }
const _hoisted_2 = ["id", "checked"]
const _hoisted_3 = ["for"]


import {useDefaultStore} from '../store/index'

export default /*#__PURE__*/_defineComponent({
  props: {
    topicText: String,
    id: Number,
    selected: Boolean
  },
  setup(__props) {

const props = __props

const store = useDefaultStore()
  
 
  const selectQuestion = (event: any) => {
      const topic = {
        id: props.id,
        selected: event.target.checked
      }      
      store.updateTopic(topic)
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      id: __props.id?.toString(),
      type: "checkbox",
      checked: __props.selected,
      onChange: selectQuestion
    }, null, 40, _hoisted_2),
    _createElementVNode("label", {
      for: __props.id?.toString()
    }, _toDisplayString(__props.topicText), 9, _hoisted_3)
  ]))
}
}

})